import { SupplementaryMaterialActionTypes } from "models/actionTypes/supplementaryMaterialActionTypes";
import { ReduxConstants } from "utils/constants";

export const supplementaryMaterialAccepted = (id: number): SupplementaryMaterialActionTypes => {
  return {
    type: ReduxConstants.SupplementaryMaterialActions.SUPPLEMENTARY_MATERIAL_ACCEPTED,
    payload: id,
  };
};

export const supplementaryMaterialSnoozed = (id: number): SupplementaryMaterialActionTypes => {
  return {
    type: ReduxConstants.SupplementaryMaterialActions.SUPPLEMENTARY_MATERIAL_SNOOZED,
    payload: id,
  };
};
